import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGIN_USER_GOOGLE,

} from '../actions';
import { getCurrentUser } from '../../helpers/Utils';
import { isAuthGuardActive, currentUser } from '../../constants/defaultValues';

const INIT_STATE = {
  currentUser: isAuthGuardActive ? getCurrentUser() : currentUser,
  forgotUserMail: '',
  newPassword: '',
  resetPasswordCode: '',
  loading: false,
  typeError: '',
  error: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true, error: '', typeError: '' };
    case LOGIN_USER_SUCCESS:
      return { ...state, loading: false, currentUser: action.payload, error: '' };
    case LOGIN_USER_ERROR:
      return {
        ...state,
        loading: false,
        currentUser: null,
        typeError: action.payload.message.code,
        error: action.payload.message.message,
      };
    case LOGIN_USER_GOOGLE:
      return { ...state, loading: true, error: '', typeError: '' };
    default:
      return { ...state };
  }
};
